import TenderSidePanel from './TenderSidePanel';

export default TenderSidePanel;
